import type {GridGroupingColDefOverride} from "@mui/x-data-grid-premium";
import React from "react";
import {SupplierFilter} from "../filters/SupplierFilter.tsx";
import {GROUP_KEY} from "../CategorizationTableDataModel.ts";

export function getGroupByHeaderColDef(supplierDataName: string, supplierColWidth: number | undefined): GridGroupingColDefOverride {
    return {
        headerName: supplierDataName,
        // width: supplierColWidth ?? 200,
        renderHeaderFilter: params => <SupplierFilter {...params} />,
        leafField: GROUP_KEY,
    }
}
